import dddMetadata from './data/ddd-metadata.json';
import type { TelefoneDddDataVersion } from './ddd-types.js';

export const TELEFONE_DDD_DATA_VERSION: TelefoneDddDataVersion =
  dddMetadata as TelefoneDddDataVersion;
